"use client";
import { Box, Container, Typography } from "@mui/material";
import React from "react";
import EnquiryForm from "./EnquiryForm";

export default function ErrorHandle() {
  return (
    <Container>
      <Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              fontFamily: "'blauerNue', 'blauerNue Fallback'",
              fontSize: { xs: "2rem", md: "3rem" },
              my: "1rem",
              fontWeight: 600,
              textAlign: "center",
              color: "#060273",
              lineHeight: { xs: "32px", md: "40px" },
            }}
          >
            Oops! There’s nothing to show here right now
          </Typography>
          <Typography
            sx={{
              textAlign: "center",
              fontFamily: "'blauerNue', 'blauerNue Fallback'",
              lineHeight: "20px",
            }}
          >
            But don’t worry—we’re here to help! 😊 Fill out our quick form, and we’ll provide
            personalized suggestions just for you.
          </Typography>
        </Box>
        <Box sx={{ mt: "1rem" }}>
          <EnquiryForm open={true} onClose={() => {}} isRelativeToPage />
        </Box>
      </Box>
    </Container>
  );
}
